import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmDialog } from "@/shared/components/ConfirmDialog";
import { toast } from "@/shared/lib/toast";

import { useDeleteSKU } from "../api/use-delete-sku";

interface DeleteSKUConfirmProps {
  sku: string;
  onClose: () => void;
}

export function DeleteSKUConfirm({ sku, onClose }: DeleteSKUConfirmProps): JSX.Element {
  const { t } = useTranslation("inventory");
  const { mutate, isPending } = useDeleteSKU();

  function handleConfirm(): void {
    mutate(sku, {
      onSuccess: () => {
        toast.success(t("confirm.delete_sku.success", { sku }));
        onClose();
      },
    });
  }

  return (
    <ConfirmDialog
      title={t("confirm.delete_sku.title")}
      description={t("confirm.delete_sku.description")}
      confirmWord="DELETE"
      confirmPlaceholder={t("confirm.delete_sku.type_to_confirm")}
      onConfirm={handleConfirm}
      onCancel={onClose}
      isPending={isPending}
      confirmLabel={t("confirm.delete_sku.action_delete")}
      cancelLabel={t("confirm.delete_sku.action_cancel")}
    />
  );
}
